export const genres = [
  { name: '奇幻', count: 42, icon: 'ri-magic-line', note: '妖精、异世界与冒险' },
  { name: '日常', count: 35, icon: 'ri-sun-line', note: '轻松温馨的生活流' },
  { name: '悬疑', count: 21, icon: 'ri-mist-line', note: '推理与氛围叙事' },
  { name: '治愈', count: 28, icon: 'ri-heart-3-line', note: '温柔舒缓的作品' },
  { name: '科幻', count: 18, icon: 'ri-robot-2-line', note: '机械与未来设定' },
  { name: '校园', count: 26, icon: 'ri-building-4-line', note: '青春与成长' },
  { name: '冒险', count: 24, icon: 'ri-compass-3-line', note: '旅途与探索' },
  { name: '恋爱', count: 19, icon: 'ri-heart-line', note: '心动与羁绊' },
];